import { createGridLayout, createGridItem } from "../../../../store/global/gridlayout";
import { createVenueData } from "../../models/venue-data-mode";

export const venueState = {
  venues: [],
  venueDetailsFlag: false,
  selectedVenue: createVenueData({}),
  selectedVenueLoading: false,
  venueStartRow: 0,
  venueList:null,
  venueDetails: [],
  // selectedVenueData: createVenueData({}),

  // venueGridLayout: createGridLayout({
  //   layout: [
  //     createGridItem({
  //       x: 0,
  //       y: 0,
  //       w: 30,
  //       h: 25,
  //       i: 'location_info',
  //     }),
  //     createGridItem({
  //       x: 30,
  //       y: 0,
  //       w: 30,
  //       h: 25,
  //       i: 'related_contacts',
  //     }),
  //     createGridItem({
  //       x: 0,
  //       y: 15,
  //       w: 30,
  //       h: 15,
  //       i: 'communication_info',
  //     }),
  //     createGridItem({
  //       x: 30,
  //       y: 15,
  //       w: 15,
  //       h: 15,
  //       i: 'private_comments',
  //     }),
  //     createGridItem({
  //       x: 45,
  //       y: 15,
  //       w: 15,
  //       h: 15,
  //       i: 'public_comments',
  //     }),
  //     createGridItem({
  //       x: 0,
  //       y: 60,
  //       w: 60,
  //       h: 5,
  //       i: 'additional_info',
  //     }),
  //     createGridItem({
  //       x: 0,
  //       y: 65,
  //       w: 20,
  //       h: 15,
  //       i: 'features',
  //     }),
  //     createGridItem({
  //       x: 20,
  //       y: 65,
  //       w: 20,
  //       h: 23,
  //       i: 'merchandise_info',
  //     }),
  //     createGridItem({
  //       x: 40,
  //       y: 65,
  //       w: 20,
  //       h: 23,
  //       i: 'genres',
  //     }),
  //     createGridItem({
  //       x: 0,
  //       y: 75,
  //       w: 20,
  //       h: 15,
  //       i: 'related_files',
  //     }),
  //     createGridItem({
  //       x: 0,
  //       y: 90,
  //       w: 20,
  //       h: 15,
  //       i: 'location_info',
  //     }),
  //     createGridItem({
  //       x: 20,
  //       y: 88,
  //       w: 20,
  //       h: 22,
  //       i: 'sponsoring_info',
  //     }),
  //     createGridItem({
  //       x: 40,
  //       y: 88,
  //       w: 20,
  //       h: 22,
  //       i: 'custom_field',
  //     }),
  //     createGridItem({
  //       x: 0,
  //       y: 110,
  //       w: 60,
  //       h: 5,
  //       i: 'vert_tab_title_bookings',
  //     }),
  //     createGridItem({
  //       x: 0,
  //       y: 115,
  //       w: 60,
  //       h: 25,
  //       i: 'tab_title_bookings',
  //     }),
  //   ]
  // })
}